export var SortingDirection;
(function (SortingDirection) {
    SortingDirection["None"] = "none";
    SortingDirection["Ascending"] = "ascending";
    SortingDirection["Descending"] = "descending";
})(SortingDirection || (SortingDirection = {}));
